import {memo} from 'react';

import type {SVGProps} from 'react';

export const DocumentIcon = memo(function DocumentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M21.6515 6.66666H11.2728C10.2022 6.66666 9.3335 7.53532 9.3335 8.60599V28.7267C9.3335 29.798 10.2022 30.6667 11.2728 30.6667H26.0602C27.1315 30.6667 28.0002 29.798 28.0002 28.7273V13.054C28.0002 12.702 27.8608 12.3647 27.6135 12.1147L22.5982 7.06066C22.3482 6.80866 22.0075 6.66666 21.6515 6.66666Z"
          fill="var(--icon-fill-cyan)"
        />
        <path
          d="M25.6668 13.4607V9.66666L19.6668 3.66666H8.3335C7.20016 3.66666 6.3335 4.53332 6.3335 5.66666V11.986"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1772 28.3333H23.6666C24.7999 28.3333 25.6666 27.4667 25.6666 26.3333V18.454"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.6665 9.66668H20.9998C20.2632 9.66668 19.6665 9.07001 19.6665 8.33334V4.33334"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.49685 22L3.50352 21.55V17.6033C3.50352 16.2833 4.54085 15.246 5.86085 15.246C7.18085 15.246 8.21819 16.2833 8.21819 17.6033V21.2667L8.17085 25.1793V26.4047C8.17085 26.5933 8.12352 26.7347 8.07685 26.876L6.28552 29.8927C6.09685 30.27 5.53152 30.27 5.34285 29.8927L3.55152 26.876C3.50419 26.7347 3.45752 26.5933 3.45752 26.4047V25.6653"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.73926 19.4427H8.17059"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.6668 13.6667H11.3335"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.7162 17.6667H11.3335"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.7588 23.8727H16.4261C16.7155 23.8727 16.9915 23.7533 17.1901 23.5427L17.7881 22.9067C18.0315 22.648 18.4375 22.632 18.7008 22.8713L19.2468 23.3687C19.6035 23.6933 20.0688 23.8733 20.5508 23.8733H22.0141"
          fill="white"
        />
        <path
          d="M15.7588 23.8727H16.4261C16.7155 23.8727 16.9915 23.7533 17.1901 23.5427L17.7881 22.9067C18.0315 22.648 18.4375 22.632 18.7008 22.8713L19.2468 23.3687C19.6035 23.6933 20.0688 23.8733 20.5508 23.8733H22.0141"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
